// extracted by mini-css-extract-plugin
export var gif = "_lc-0";